module.exports = __webpack_public_path__ + "img/x.b2696e0c.svg";